(() => {
  const init = (root) => {
    if (!root || root.dataset.uklhReady === 'true') return;
    root.dataset.uklhReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = [...root.querySelectorAll('.uklh-reveal')];

    if (!reducedMotion && 'IntersectionObserver' in window) {
      revealItems.forEach((item) => item.classList.add('uklh-will-reveal'));
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((item) => revealObserver.observe(item));
    }

    const nav = root.querySelector('[data-uklh-nav]');
    const navLinks = nav ? [...nav.querySelectorAll('a[href^="#"]')] : [];
    const sections = navLinks
      .map((link) => root.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if ('IntersectionObserver' in window && sections.length) {
      const activeObserver = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        navLinks.forEach((link) => {
          link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`);
        });
      }, { rootMargin: '-25% 0px -55% 0px', threshold: [0.05, 0.2, 0.5] });
      sections.forEach((section) => activeObserver.observe(section));
    }

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    const delivery = root.querySelector('[data-uklh-delivery]');
    const collection = root.querySelector('[data-uklh-collection]');
    if (delivery && collection) {
      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      delivery.min = today.toISOString().slice(0, 10);
      delivery.addEventListener('change', () => {
        collection.min = delivery.value;
        if (collection.value && collection.value < delivery.value) collection.value = '';
      });
    }

    const mobileCta = root.querySelector('[data-uklh-mobile-cta]');
    const quote = root.querySelector('[id^="uklh-quote-"]');
    if (mobileCta && quote && 'IntersectionObserver' in window) {
      let heroPassed = false;
      const updateCta = (quoteVisible = false) => {
        mobileCta.classList.toggle('is-visible', heroPassed && !quoteVisible);
      };
      const hero = root.querySelector('.uklh__hero');
      const heroObserver = new IntersectionObserver(([entry]) => {
        heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateCta(false);
      });
      const quoteObserver = new IntersectionObserver(([entry]) => updateCta(entry.isIntersecting), { threshold: 0.08 });
      if (hero) heroObserver.observe(hero);
      quoteObserver.observe(quote);
    }

    const success = root.querySelector('.uklh__form-success');
    if (success) success.focus();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-uklh-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
